import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pageImages } from '../../data/siteData';
import PagePhotoViewer from '../../elements/PagePhotoViewer';

const page = {
  "slug": "textile-mills-cotton-gins",
  "title": "Textile Mills & Cotton Gins",
  "summary": "Cotton, textile, gin trash, biomass, and fiber baling equipment for difficult material streams.",
  "image": "equipment/horizontal-balers/textiles.jpg",
  "highlights": [
    "Material-specific recommendations",
    "Baler loading and discharge planning",
    "Serviceable equipment design"
  ],
  "section": "Industries"
};

const navItems = [
  {
    "slug": "paper-mills",
    "title": "Paper Mills"
  },
  {
    "slug": "corrugated-container-manufacturers",
    "title": "Corrugated Container Manufacturers"
  },
  {
    "slug": "nonwoven-mills",
    "title": "Nonwoven Mills"
  },
  {
    "slug": "textile-mills-cotton-gins",
    "title": "Textile Mills & Cotton Gins"
  },
  {
    "slug": "distribution-centers",
    "title": "Distribution Centers"
  },
  {
    "slug": "manufacturers-industrial-plants",
    "title": "Manufacturers & Industrial Plants"
  },
  {
    "slug": "warehouses",
    "title": "Warehouses"
  },
  {
    "slug": "recycling-centers",
    "title": "Recycling Centers"
  }
];

const images = pageImages['textile-mills-cotton-gins'];


function TextileMillsCottonGins() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          {navItems.map((item) => (
            <Link key={item.slug} className={item.slug === page.slug ? 'active' : ''} to={`/${item.slug}`}>{item.title}</Link>
          ))}
        </aside>
        <article className="article">
          <span className="eyebrow">{page.section}</span>
          <h2>{page.title}</h2>
          <div className="body-copy page-summary-copy">{page.summary}</div>
          {page.highlights?.length ? (
            <div className="page-summary-notes">
              {page.highlights.map((item) => <span key={item}>{item}</span>)}
            </div>
          ) : null}
          <PagePhotoViewer title={page.title} images={images} leadText={"C+M product pages cover cotton, tobacco, textile goods, manmade fibers, natural fibers, used clothing, cotton gin trash, and biomass applications."} eyebrow="Application Photos" />
          <div className="content-stack">
            <section className="content-block">
              <h3>Textiles, Cotton, and Gin Trash</h3>
              <div className="body-copy">C+M product pages cover cotton, tobacco, textile goods, manmade fibers, natural fibers, <strong>used clothing</strong>, cotton gin trash, and <strong>biomass</strong> applications.</div>
              <div className="body-copy">Full-eject and specialty balers are often the right discussion when fibers, clothing, films, or springy materials need clean bale ejection and consistent handling.</div>
              <div className="detail-points">
                <div className="detail-point">Cotton and textile fiber handling</div>
                <div className="detail-point">Used clothing and apparel recycling</div>
                <div className="detail-point">Cotton gin trash and biomass baling</div>
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default TextileMillsCottonGins;
